import axios, { AxiosError, AxiosResponse } from "axios"
import api from "../../services/api.service"
import { IResponseCourses, IResponsePrograms } from "./dict.type"

const route = '/dict'
axios.defaults.withCredentials = true


/** Получение данных по справочнику - Курсы */
export const getCourses = async () => {
    let response: IResponseCourses

    try {
        const res: AxiosResponse<IResponseCourses, AxiosError> = await api.get(`${route}/getCourses`)

        if (res.statusText !== 'ERR_NETWORK') {
            response = res.data
        } else {
            response = {
                status: 500, 
                message: 'Сервер временно не доступен.',
                errors: null
            }
        }

        return response
    } catch(error) {
        if ((error as AxiosError).code === 'ERR_NETWORK') {
            response = {
                status: 500, 
                message: 'Сервер не доступен', 
                errors: (error as AxiosError).code
            }
            
            return response 
        }

        const resError = (error as AxiosError).response?.data as IResponseCourses
        response = {status: 500, message: resError?.message, errors: resError.errors}

        return response
    }
}
/** Получение данных по справочнику - Курсы */
export const getPrograms = async (courseID: number) => {
    let response: IResponsePrograms

    try {
        const res: AxiosResponse<IResponsePrograms, AxiosError> = await api.get(`${route}/getPrograms?courseID=${courseID}`)

        if (res.statusText !== 'ERR_NETWORK') {
            response = res.data
        } else {
            response = {
                status: 500, 
                message: 'Сервер временно не доступен.',
                errors: null
            }
        }

        return response
    } catch(error) {
        if ((error as AxiosError).code === 'ERR_NETWORK') {response = {status: 500, message: 'Сервер не доступен', errors: (error as AxiosError).code}; return response}

        const resError = (error as AxiosError).response?.data as IResponsePrograms
        response = {status: 500, message: resError?.message, errors: resError.errors}
        return response
    }
}